module.exports = __webpack_public_path__ + "static/media/commerce-tag-icon.a0e3d4a9.svg";